import React, { useState } from 'react'
import { Copy, Check } from 'lucide-react'
import { useI18n } from '../../i18n'
import { toPolicyDisplayId, copyToClipboard } from '../../utils/policyDisplayId'
import listStyles from '@/styles/pages/governance/GovernanceListing.module.scss'

type Props = {
  uuid: string
  showFull?: boolean
}

export function PolicyDocumentUuidCell({ uuid, showFull = false }: Props) {
  const { t } = useI18n()
  const [copied, setCopied] = useState(false)
  const shortId = toPolicyDisplayId(uuid)
  const label = showFull ? uuid : shortId || uuid.slice(0, 8)

  const handleCopy = async () => {
    await copyToClipboard(uuid)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <div className={listStyles.actionsGap}>
      <code className="text-xs">{label}</code>
      <button
        type="button"
        className="border-0 bg-transparent p-0 text-blue-600 hover:underline text-xs inline-flex items-center gap-1"
        onClick={handleCopy}
        title={t('governance.documentLifecycle.copyUuid', 'Copy UUID')}
      >
        {copied ? <Check size={14} /> : <Copy size={14} />}
        {t('governance.documentLifecycle.copyUuid', 'Copy UUID')}
      </button>
    </div>
  )
}
